"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRefSetter = void 0;

var _react = require("react");

var useRefSetter = function useRefSetter(innerRef, forwardedRef) {
  return (0, _react.useCallback)(function (ref) {
    innerRef.current = ref; // external ref

    if (forwardedRef) {
      if (typeof forwardedRef === 'function') {
        forwardedRef(ref);
      } else {
        forwardedRef.current = ref;
      }
    }
  }, [forwardedRef, innerRef]);
};

exports.useRefSetter = useRefSetter;